import React,{useState} from "react";
import TeamPageBanner from "../Components/Banners/TeamPageBanner";
import TeamPageMemberCards from "../Components/Team/TeamPageMemberCards";
import Footer from "../Components/Footer";
import TeamPageBar from "../Components/Navbar/TeamPageBar";
import ComingSoon from "../Components/ComingSoon";
import TeamData from "../utils/TeamData"

export default function Team({ darkToggle, setDarkToggle }) {
  const [comingSoon, setComingSoon] = useState(false);

  const showPopup = () => {
    setComingSoon(!comingSoon);
  };
  return (
    <div className="flex flex-col items-center">
      <TeamPageBar
        darkToggle={darkToggle}
        setDarkToggle={setDarkToggle}
        showPopup={showPopup}
        comingSoon={comingSoon}
      />
      {comingSoon && <ComingSoon showPopup={showPopup} />}

      <marquee className="bg-sky-500 p-4 text-white" direction="right">
        The core team registration are now closed. Please signup and follow us on all social platforms to remain informed about the next opening.
      </marquee>

      <TeamPageBanner />
      
      <TeamPageMemberCards TeamData={TeamData}/>


      <Footer />
    </div>
  );
}
